import axios from 'axios';

class FileApi {
    uploadFile({ url, payload, onUploadProgress }) {
        return axios({
            url,
            method: 'POST',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'json',
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                if (onUploadProgress) {
                    onUploadProgress(percentCompleted);
                }
            }
        });
    }
}

export default FileApi;